<template>
    <div id="relatoriosPCM">
        <b-row>
            <b-table :fields="fields" :items="items" :busy="tableBusy" hover no-border-collapse sort-by="" :sort-desc="true"
                stacked="sm" striped responsive show-empty>
                <template #empty>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template #cell(IdRelatorioNavigation.DsRelatorio)="row">
                    <b-link v-if="row.item.temParametrosAdicionais()" class="text-dark"
                        @click="abrirModalParamsAdicionais(row.item)">
                        {{ row.value }}
                    </b-link>
                    <b-link v-else class="text-dark" @click="gerarRelatorioPCM(row.item)">
                        {{ row.value }}
                    </b-link>
                </template>
                <template v-slot:cell(actions)="row">
                    <div v-if="row.item.Obrigatorio">
                        <div v-if="row.item.IdRelatorioNavigation.possuiConfirmacao()" v-b-tooltip.hover
                            title="O relatório já foi visualizado">
                            <b-badge variant="success" class="mr-2">obrigatório</b-badge>
                            <font-awesome-icon class="text-success" icon="check" />
                        </div>
                        <div v-else v-b-tooltip.hover title="A visualização deste relatório ainda está pendente!">
                            <b-badge variant="warning" class="mr-2">obrigatório</b-badge>
                            <font-awesome-icon class="text-warning" icon="spinner" />
                        </div>
                    </div>
                    <div v-if="row.item.temParametrosAdicionais()">
                        <div v-b-tooltip.hover title="O relatório precisa de parâmetros adicionais para ser gerado">
                            <b-badge variant="info" class="mr-2">parâmetros</b-badge>
                            <font-awesome-icon class="text-info" icon="rectangle-list" />
                        </div>
                    </div>
                </template>
            </b-table>
        </b-row>
        <modal-relatorio-gestao v-if="relatorioMpa && exibirModalParametrosAdicionais"
            @fecharModal="exibirModalParametrosAdicionais = false" :loading="loadingMpa"
            :titulo="relatorioMpa.IdRelatorioNavigation.DsRelatorio" :pdfData="pdfData">
            <b-card>
                <b-row v-if="relatorioMpa.empenhoComParametrosAdicionais()" class="mb-2 d-flex align-items-center">
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group id="input-group-type" label-size="md" label="Número do Empenho">
                            <b-form-input v-model="paramsAdicionais.numeroEmpenho" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group id="input-group-type" label-size="md" label="Código da Unidade Orçamentária">
                            <b-form-input v-model="paramsAdicionais.codUnidadeOrcamentaria" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-button :disabled="!parametrosAdicionaisPreenchidos(relatorioMpa)"
                            @click="gerarRelatorioPCM(relatorioMpa)" class="ml-3">
                            Gerar Relatório
                        </b-button>
                    </b-col>
                </b-row>
                <b-row v-else class="mb-2 d-flex align-items-center">
                    <b-col cols="12" md="6" lg="2">
                        <b-form-group id="input-group-type" label-size="md" label="Ano do Empenho">
                            <b-form-input v-model="paramsAdicionais.anoEmpenho" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="2">
                        <b-form-group id="input-group-type" label-size="md" label="Número do Empenho">
                            <b-form-input v-model="paramsAdicionais.numeroEmpenho" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="3">
                        <b-form-group id="input-group-type" label-size="md" label="Código da Unidade Orçamentária">
                            <b-form-input v-model="paramsAdicionais.codUnidadeOrcamentaria" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="2">
                        <b-form-group id="input-group-type" label-size="md" label="Tipo Resto a Pagar">
                            <b-form-select v-model="paramsAdicionais.tipoRestoAPagar" :options="tiposRestosAPagar" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="3">
                        <b-button :disabled="!parametrosAdicionaisPreenchidos(relatorioMpa)"
                            @click="gerarRelatorioPCM(relatorioMpa)" class="ml-3">
                            Gerar Relatório
                        </b-button>
                    </b-col>
                </b-row>
            </b-card>
        </modal-relatorio-gestao>
        <modal-pdf v-if="exibirModalPdf" @fecharModal="exibirModalPdf = false" :pdfData="pdfData" :filename="filename"
            :dadosLogObrigatorio="dadosLogObrigatorio" @confirmarVisualizacao="confirmarVisualizacao" />
    </div>
</template>

<script lang="ts">
/* eslint-disable */
import { store } from "@/store";
import { mixins } from 'vue-class-component'
import { Vue, Component } from 'vue-property-decorator'
import { UtilsTS } from '@/utilsts'

import { fieldsRelatoriosPCM } from '@/types/entregas/pcm/fields-prestacao-contas-mensal-relatorios'
import pcmService from "@/services/entregas/pcmService"
import ModalPdf from "@/components/ModalPdf.vue"
import ModalRelatorioGestao from "@/components/ModalRelatorioGestao.vue"
import { RelatorioPCM } from '@/types/entregas/pcm/relatorio-pcm'
import { TableField } from '@/types/table-field'
import { RelatorioObrigatorio } from "@/types/relatorios/relatorio-obrigatorio";
import { PortalError } from "@/types/portal-error";

const CompProps = Vue.extend({
    name: 'RelatoriosPCM',
    components: { ModalPdf, ModalRelatorioGestao },
    props: {
        idpcm: {
            type: String
        }
    },
})

@Component
export default class RelatoriosPCM extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsRelatoriosPCM
    items: RelatorioPCM[] = [];
    prestacao: any = {}
    showFilters = true
    tableBusy = false

    //campos ligados a visualização de PDF
    filename = ''
    pdfData: any = null
    exibirModalPdf = false
    dadosLogObrigatorio?: RelatorioObrigatorio


    //relatórios com parâmetros extra
    exibirModalParametrosAdicionais = false
    loadingMpa = false
    relatorioMpa: RelatorioPCM | null = null
    paramsAdicionais: any = {
        anoEmpenho: null,
        numeroEmpenho: null,
        codUnidadeOrcamentaria: null,
        tipoRestoAPagar: null,
    }
    tiposRestosAPagar: any[] = [
        { value: null, text: 'Selecione', disabled: true },
        { value: 1, text: 'Processado' },
        { value: 2, text: 'Não Processado' },
        { value: 3, text: 'Em Liquidação' }
    ]


    async mounted() {
        try {
            store.blockScreen = true
            this.prestacao = await pcmService.getByID(Number(this.idpcm))
            await this.consultarRelatorios()
        } finally {
            store.blockScreen = false
        }
    }

    async consultarRelatorios(): Promise<void> {
        this.tableBusy = true
        try {
            const retorno = await pcmService.consultarRelatorios(this.idpcm);
            this.items = retorno.sort((a, b) => a.IdRelatorioNavigation.Ordem - b.IdRelatorioNavigation.Ordem)
        } catch (e: any) {
            this.items = []
            this.tratarError(e)
        } finally {
            this.tableBusy = false
        }
    }

    async confirmarVisualizacao(): Promise<void> {
        this.consultarRelatorios()
        this.$emit('atualizarPcm')
    }


    parametrosAdicionaisPreenchidos(rel: RelatorioPCM) {
        if (rel.IdRelatorioNavigation.NomeRelatorio === "DetalhesRestoPagar") {
            if ((this.paramsAdicionais.numeroEmpenho !== null && this.paramsAdicionais.numeroEmpenho !== null)
                && (this.paramsAdicionais.anoEmpenho !== null && this.paramsAdicionais.anoEmpenho !== null)
                && (this.paramsAdicionais.codUnidadeOrcamentaria !== null && this.paramsAdicionais.codUnidadeOrcamentaria !== null)
                && (this.paramsAdicionais.tipoRestoAPagar !== null && this.paramsAdicionais.tipoRestoAPagar !== null)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            if ((this.paramsAdicionais.numeroEmpenho !== null && this.paramsAdicionais.numeroEmpenho !== null)
                && (this.paramsAdicionais.codUnidadeOrcamentaria !== null && this.paramsAdicionais.codUnidadeOrcamentaria !== null)) {
                return true
            }
            else {
                return false;
            }
        }
    }

    /**
     * Obtém relatório de PCM e renderiza no componente PDFViewer.
     * 
     * @since 20230816
     */
    async gerarRelatorioPCM(rel: RelatorioPCM) {
        try {
            this.pdfData = null;
            this.exibirModalPdf = false;
            store.blockScreen = true;

            let response;
            if (rel.temParametrosAdicionais()) {
                response = await pcmService.downloadRelatorioParametrosAdicionais(String(rel.IdRelatorioPcm), this.idpcm, this.paramsAdicionais);
                if (response && response.status === 200) {
                    this.pdfData = response.data.ArquivoPdf;
                } else throw new PortalError('Erro ao obter o relatório')
            } else {
                response = await pcmService.downloadRelatorio(String(rel.IdRelatorioPcm), this.idpcm);
                if (response && response.status == 200) {
                    // conversão powered by GePeTo
                    // Convert Base64 to ArrayBuffer
                    var binaryString = window.atob(response.data.ArquivoPdf);
                    var byteArray = new Uint8Array(binaryString.length);
                    for (var i = 0; i < binaryString.length; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }

                    // Create Blob from ArrayBuffer
                    var blob = new Blob([byteArray], { type: "application/pdf" });
                    // FIM de conversão powered by GePeTo

                    const objectUrl = URL.createObjectURL(blob);
                    this.filename = "relatorio-pcm-" + rel.IdRelatorioNavigation.DsRelatorio;
                    if (rel.Obrigatorio) {
                        this.dadosLogObrigatorio = new RelatorioObrigatorio(
                            response.data.IdLogVisualizacao,
                            rel.IdRelatorioNavigation,
                            rel.IdRelatorioNavigation.LogVisualizacao
                        )
                    } else {
                        this.dadosLogObrigatorio = undefined
                    }
                    this.pdfData = objectUrl;
                    this.exibirModalPdf = true
                }
                else {
                    if (response && response.data && response.data.msg)
                        this.$toast.error(response.data.msg);
                    else this.$toast.error("Erro ao obter o arquivo");
                }
            }
        } catch (e: any) {
            this.tratarError(e)
            this.dadosLogObrigatorio = undefined
            this.pdfData = ''
            this.exibirModalPdf = false
        } finally {
            store.blockScreen = false;
        }
    }

    //métodos de relatórios com parâmetros adicionais
    abrirModalParamsAdicionais(item: RelatorioPCM) {
        this.exibirModalParametrosAdicionais = true
        this.relatorioMpa = item
        this.paramsAdicionais = {
            anoEmpenho: null,
            numeroEmpenho: null,
            codUnidadeOrcamentaria: null,
            tipoRestoAPagar: null,
        }
    }
}
</script>

<style></style>